module.exports = {
          srcSet: __webpack_public_path__ + "427d97d9.jpg"+" 700w"+","+__webpack_public_path__ + "5868542f.jpg"+" 1400w"+","+__webpack_public_path__ + "d67d617f.jpg"+" 2100w"+","+__webpack_public_path__ + "0af50ca9.jpg"+" 2722w",
          images:[ {path: __webpack_public_path__ + "427d97d9.jpg",width: 700,height: 466},{path: __webpack_public_path__ + "5868542f.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "d67d617f.jpg",width: 2100,height: 1400},{path: __webpack_public_path__ + "0af50ca9.jpg",width: 2722,height: 1815}],
          src: __webpack_public_path__ + "427d97d9.jpg",
          toString:function(){return __webpack_public_path__ + "427d97d9.jpg"},
          
          width: 700,
          height: 466
        }